<div 
    v-if="filters.length"
    class="grid grid-x grid-margin-x align-middle pagelist-filters">
    <template v-for="filter of filters">
        <div  
            v-if="filter.options.length"
            class="pagelist-filter js-pagelist-filter cell small-12 medium-6 large-4"
            @mouseleave="closeFilter($event)"
        >
            <button
                class="pagelist-filter-toggle"
                @click="toggleFilter($event)"
            >
                Select a {{ filter.name }}
            </button>
            <div class="pagelist-spacer">
            </div>
            <div 
                class="pagelist-filter-options"
            >
                <div
                    v-for="(option, index) in filter.options"
                >   
                    <!--
                        the final checkbox needs a 'closeFilter'
                        function on blur (to enable us to have
                        filters close automatically when we
                        navigate between them using the keyboard)
                    -->
                    <input 
                        type="checkbox" 
                        :id="option.id"
                        :value="option.id"
                        :name="option.name"
                        :data-filter="filter.id"
                        :checked="option.checked"
                        @change=handleCheckbox($event)
                        v-if="index === (filter.options.length - 1)"
                        @blur="closeFilter($event)"
                    >
                    <input 
                        type="checkbox" 
                        :id="option.id"
                        :value="option.id"
                        :name="option.name"
                        :data-filter="filter.id"
                        :checked="option.checked"
                        @change=handleCheckbox($event)
                        v-else
                    >
                    <label 
                        :for="option.id"
                    >
                        {{ option.name }}
                    </label>                
                </div>
            </div>
        </div>
    </template>
    <label class="pagelist-search-label cell small-12 medium-6 large-4">
        <input 
            v-if="config.showSearchField"
            type="text" 
            v-model="titleFilter"
            class="pagelist-search-input"
            placeholder="Search by name"
        >
    </label>
</div>
